import {createI18n} from 'vue-i18n';
import {Auth} from "@/services/Api";

import moment from 'moment/min/moment-with-locales'

import 'moment/locale/pt-br';
import * as momentTz from "moment-timezone";

import {nextTick} from "vue";
import axios from "axios";

declare const navigator: any;
declare const document: any;

export const SUPPORT_LOCALES = ['en', 'en-US', 'es', 'fr', 'pt-BR', 'pt'];
export const LOADED_LOCALES: Array<any> = [];

export const i18n = createI18n({
    locale: getLocale()
})

export async function setI18nLocale(i18n:any, locale:string) {
    if(!SUPPORT_LOCALES.includes(locale)) {
        return;
    }

    locale = locale.replace('_', '-')

    if(locale === 'en-US') {
        locale = 'en';
    }

    if (!LOADED_LOCALES.includes(locale)) {
        const messages = await import(
            /* webpackChunkName: "locale-[request]" */ `@/assets/locales/${locale}.json`
        )

        i18n.global.setLocaleMessage(locale, messages.default)

        LOADED_LOCALES.push(locale)
    }

    if (i18n.mode === 'legacy') {
        i18n.global.locale = locale
    } else {
        i18n.global.locale.value = locale
    }

    axios.defaults.headers.common['Accept-Language'] = locale;

    document.querySelector('html').setAttribute('lang', locale)

    return nextTick();
}

export function dt(...args:any) {
    const locale = i18n.global.locale;

    moment.locale(locale)

    momentTz.updateLocale(locale, moment.localeData()._config);

    momentTz.tz.setDefault(
        Auth.currentUser()?.timezone || momentTz.tz.guess()
    );

    return momentTz.tz(args[0], args[1] || momentTz.tz.guess())
}

export function getLocale() {
    return navigator.language || navigator?.userLanguage || 'en';
}